import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../../constants/app.constants";
import { CreateRingFenceRequest, RingFenceResponse } from "../../models/ringFence";
import { GetAllRingFencesKey, GetRingFencesByScenarioKey } from "./constants";

const API_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/ring-fence`;

const createRingFence = async (
  data: CreateRingFenceRequest
): Promise<RingFenceResponse> => {
  const response = await axios.post<RingFenceResponse>(API_URL, data);
  return response.data;
};

const useCreateRingFence = () => {
  const queryClient = useQueryClient();

  return useMutation<RingFenceResponse, AxiosError, CreateRingFenceRequest, unknown>(
    createRingFence,
    {
      onSuccess: async (data, variables) => {
        // Invalidate related queries
        await queryClient.invalidateQueries(GetAllRingFencesKey);
        await queryClient.invalidateQueries([
          GetRingFencesByScenarioKey,
          variables.scenarioId
        ]);
      }
    }
  );
};

export default useCreateRingFence;
